"use strict";

var _slicedToArray = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _taggedTemplateLiteral = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _templateObject, _templateObject2, _templateObject3;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Radio = require("@mui/material/Radio");
var _Radio2 = _interopRequireDefault(_Radio);
var _QuestionContainer = require("../QuestionContainer");
var _QuestionContainer2 = _interopRequireDefault(_QuestionContainer);
var _styledComponents = require("styled-components");
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _QuestionText = require("../QuestionText");
var _QuestionText2 = _interopRequireDefault(_QuestionText);
var _TextField = require("@mui/material/TextField");
var _TextField2 = _interopRequireDefault(_TextField);
var _Slider = require("@mui/material/Slider");
var _Slider2 = _interopRequireDefault(_Slider);
var _useQuestionAnswer = require("../../hooks/use-question-answer");
var _useQuestionAnswer2 = _interopRequireDefault(_useQuestionAnswer);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Row = _styledComponents2.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding-top: 10px;\n"])));
var Col = _styledComponents2.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n"])));
var SpacedRow = _styledComponents2.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  padding-top: 10px;\n  align-items: center;\n  justify-content: space-between;\n"])));
exports.default = function (_ref) {
  var question = _ref.question,
    onChangeAnswer = _ref.onChangeAnswer;
  var _ref2 = (0, _useQuestionAnswer2.default)(question, onChangeAnswer, question.defaultAnswer || undefined),
    _ref3 = _slicedToArray(_ref2, 2),
    _ref3$ = _ref3[0],
    answer = _ref3$.answer,
    error = _ref3$.error,
    changeAnswer = _ref3[1];
  var _ref4 = (0, _react.useState)(answer),
    _ref5 = _slicedToArray(_ref4, 2),
    textFieldText = _ref5[0],
    changeTextFieldText = _ref5[1];
  return _react2.default.createElement(_QuestionContainer2.default, {
    question: question,
    answered: answer !== undefined,
    fadedTitle: question.unit ? "(".concat(question.unit, ")") : undefined,
    error: error
  }, _react2.default.createElement(Row, null, _react2.default.createElement(_TextField2.default, {
    style: {
      border: "1px solid #ccc",
      borderRadius: 2,
      marginRight: 10,
      width: 80
    },
    id: question.id ? question.id + "Text" : "",
    inputProps: {
      style: {
        textAlign: "center"
      }
    },
    value: textFieldText || "",
    onChange: function onChange(e) {
      var tft = e.target.value;
      changeTextFieldText(tft);
      var tfn = parseFloat(tft);
      if (!isNaN(tfn) && tfn <= question.max && tfn >= question.min) {
        changeAnswer(tfn);
      }
    }
  }), _react2.default.createElement(Col, null, _react2.default.createElement(_Slider2.default, {
    onChange: function onChange(e, value) {
      console.log({
        value: value
      });
      changeAnswer(value);
      changeTextFieldText(value.toFixed(2));
    },
    id: question.id ? question.id + "Slider" : "",
    style: {
      opacity: answer === undefined ? 0.5 : 1
    },
    value: answer === undefined ? (question.max + question.min) / 2 : answer,
    min: question.min,
    max: question.max,
    step: question.step || 1
  }), _react2.default.createElement(SpacedRow, null, _react2.default.createElement(_QuestionText2.default, null, question.min), _react2.default.createElement(_QuestionText2.default, null, question.max)))));
};